import React from 'react';

const Img = (props) => {
    return (<div style={{
        width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
    }}><img className="img" src={props.image} /></div>)
}

export default Img; 